import {Company} from '@legit.health/ui';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import EventIcon from '@mui/icons-material/Event';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {TFunction} from 'i18next';
import {CurrentPractitioner} from '@/practitioner/interfaces/Practitioner';
import practitionerPaths from '@/practitioner/routing/paths';
import QuickCheckIcon from '@/shared/components/ui/icons/QuickCheckIcon';
import ReceivePaymentsIcon from '@/shared/components/ui/icons/ReceivePaymentsIcon';
import StethoscopeIcon from '@/shared/components/ui/icons/StethoscopeIcon';
import PriorityAlertsMenuItem from './components/WorkListMenuItem';

const menuItems = ({
  currentPractitioner,
  company,
  t
}: {
  currentPractitioner: CurrentPractitioner;
  company: Company;
  t: TFunction;
}) => [
  ...(currentPractitioner.isAdmissions
    ? []
    : [
        {
          name: <PriorityAlertsMenuItem t={t} />,
          link: practitionerPaths.WORK_LIST,
          icon: <NewReleasesIcon />
        }
      ]),
  {
    name: 'practitioner/common:menu.patients',
    link: practitionerPaths.PATIENT_LIST,
    icon: <PeopleAltIcon />
  },
  ...(currentPractitioner.isAdmissions
    ? []
    : [
        {
          name: 'practitioner/common:menu.upload',
          link: practitionerPaths.DIAGNOSTIC_REPORT_REQUEST,
          icon: <AddAPhotoIcon />
        }
      ]),
  ...(currentPractitioner.practitionerPermissions.viewPractitioners
    ? [
        {
          name: 'practitioner/common:menu.practitioners',
          link: practitionerPaths.PRACTICIONER_LIST,
          icon: <StethoscopeIcon />
        },
        ...(company.stripeConnect.isPatientPaymentOrdersEnabled &&
        currentPractitioner.isQualifiedPractitioner
          ? [
              {
                name: 'practitioner/common:menu.payment',
                link: practitionerPaths.PATIENT_PAYMENT_ORDER_LIST,
                icon: <ReceivePaymentsIcon />
              }
            ]
          : [])
      ]
    : []),
  ...(currentPractitioner.practitionerPermissions.administerPractitioners
    ? [
        ...[
          {
            name: 'practitioner/common:menu.metrics',
            link: practitionerPaths.COMPANY_METRICS,
            icon: <EqualizerIcon />
          }
        ]
      ]
    : []),
  ...(currentPractitioner.isQualifiedPractitioner
    ? [
        {
          name: 'practitioner/common:menu.activity',
          link: practitionerPaths.MONTHLY_ACTIVITY,
          icon: <EventIcon />
        }
      ]
    : []),
  ...(currentPractitioner.practitionerPermissions.viewDiagnosticReports &&
  !company.isForClinicalTrials
    ? [
        {
          name: 'practitioner/common:menu.quickCheck',
          link: practitionerPaths.QUICK_DIAGNOSTIC_REPORT_REQUEST,
          icon: <QuickCheckIcon />
        }
      ]
    : [])
];

export default menuItems;
